angular.module('tmx-app').factory('ReportService', ['$http','tmxResource', function ($http,tmxResource) {
    var Report = tmxResource("Report");

    Report.ReportPDF = function (params) {
        $http.post(APP_CONSTANTS.backend + 'Report/ReportPDF', params, { responseType: 'arraybuffer' }).success(function (data) {
            var file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, params.ReportName);
        });
    }
    Report.ReportDatasourceResult = function (params) {
        return Report.getByAction("ReportDataSourceResultPost", false, 'put', params);
    }
    Report.ReportHTML = function (params) {
        return Report.getByAction("ReportHTML", false, 'post', params);
    }
    Report.GeneratePdfFromHtml = function (params) {
        $http.put(APP_CONSTANTS.backend + 'Report/GeneratePdfFromHtml', params, { responseType: 'arraybuffer' })
            .success(function (data) {
                var file = new Blob([data], { type: 'application/pdf' });
                saveAs(file, params.ReportVisibleName);
            });

    }
    Report.GetReportExcel = function (params) {
        $http.put(APP_CONSTANTS.backend + 'Report/ReportExcel', params, { responseType: 'arraybuffer' })
            .success(function (data) {
                var file = new Blob([data], { type: 'application/vnd.ms-excel' });
                saveAs(file, params.ReportVisibleName);
            });

    }

    return Report;
}]);